module.exports = __webpack_public_path__ + "img/map_all_general-group-seating-3.24d91c63.jpg";